<ng-container *ngIf="product">
  <article class="product sidebar" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
    <header>
      <div *ngIf="product.has_image" class="img">
        <img [src]="product.image_path" class="ya_image">
      </div>
      <div *ngIf="!product.has_image" class="noimg">
        <h3>{{product.label}}</h3>
      </div>
      <!-- content top right-->
      <div class="content">
        <div class="top">
          <h2>{{product.label}}</h2>
          <p [truncatedText]="product.details.description"></p>
        </div>
        <footer>
          <a class="btn" (click)="showProductInfo(product)" langkey="details_info"></a>
        </footer>
      </div>
    </header>
    <div class="content" #product_list>
      <!-- recipelink headline-->
      <ng-container *ngIf="hasContent(product.heading)">
        <div class="top headline">
          <h2>{{product.heading}}</h2>
        </div>
      </ng-container>
      <a class="dish" *ngFor="let sotProduct of product.sotProducts" [class.noimg]="!sotProduct.has_image || isModeTwo"
        [class.nodesc]="!sotProduct.details.description"
        [class.not-avail]="!sotProduct.schedule.active || !sotProduct.is_available" (click)="openProduct(sotProduct)">
        <div *ngIf="sotProduct.has_image" class="img">
          <img [src]="sotProduct.image_path" class="ya_image">
        </div>
        <div class="content container">
          <div class="top">
            <header>
              <h2>{{sotProduct.label}}</h2>
              <div class="preis">{{sotProduct.show_price | price}}</div>
            </header>
            <p [truncatedText]="sotProduct.details.description"></p>
          </div>
          <footer>
            <!--item tags -->
            <div class="preference">
              <ng-container *ngIf="isItemTagEnabled">
                <div class="product-tag">
                  <div class="tag" *ngFor="let tag of GetProductTagsById(sotProduct.product_tag_ids)"
                    id=" productTag{{tag.id}}">
                    <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
                  </div>
                </div>
              </ng-container>
            </div>
            <a class="btn insert">
              <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
            </a>
          </footer>
        </div>
        <!-- product schedule not active or product is unavailable-->
        <ng-container *ngIf="!sotProduct.schedule.active">
          <div class="not-available">
            <span>{{sotProduct.schedule.hint}}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="sotProduct.schedule.active && !sotProduct.is_available">
          <div class="not-available">
            <span langkey="details_not_available"></span>
          </div>
        </ng-container>
      </a>
      <!-- filter tag reset button-->
      <ng-container *ngIf="isItemTagEnabled && hasTagFilterSelected">
        <div class="tag-filter--reset">
          <h3 langkey="tags_reset_filter"></h3>
          <span langkey="tags_restore_filter_text"></span>
        </div>
      </ng-container>
    </div>
    <!--arrow #more items-->
    <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
      [setSVGAttributes]="{class: 'arrows'}"></div>
    <!--Side basket-->
    <aside>
      <div class="top">
        <h3 langkey="main_basket"></h3>
        <div class="container warenkorb">
        </div>
      </div>
      <div class="bottom">
        <div class="container">
          <footer>
            <sot-backbtn (click)="back()"></sot-backbtn>
          </footer>
        </div>
        <sot-langcall></sot-langcall>
      </div>
    </aside>
  </article>
</ng-container>